import { Button, Modal } from "@aqar-app/react-ui";
import { useRouter } from "next/router";
import { Icon } from "@/components/icon";

import { Linkify } from "@/components/error/ssr";
import css from "./loginAlert.module.scss";
import React from "react";
import { ClassicModal } from "@/components/Listing/ListingScreen/classicModal";

export default function LoginAlert({ text } = {}) {
  const router = useRouter();
  return (
    <Modal.ClassicOverlay className={css.loginpopup}>
      <div className={css.header}>
        <Modal.CloseButton />
      </div>
      <div className={css.body}>
        <Icon width={35} height={35} name="Warning-colored" />
        <p> {text || "يرجى تسجيل الدخول لإتمام المكالمة"}</p>
      </div>
      <div className={css.footer}>
        <Button
          onClick={(event) => {
            router
              .push(`/login?returnTo=${router.asPath}`)
              .then(() => Modal.close(event));
          }}
          theme="primary"
        >
          حسنا
        </Button>
      </div>
    </Modal.ClassicOverlay>
  );
}

export function WarningAlert({ text, onOk, okTxt } = {}) {
  return (
    <Modal.ClassicOverlay className={css.loginpopup}>
      <div className={css.header}>
        <Modal.CloseButton />
      </div>
      <div className={css.body}>
        <Icon width={35} height={35} name="Warning-colored" />
        <Linkify key={text} text={text || ""} />
      </div>
      <div className={css.footer}>
        <Button
          onClick={(event) => {
            Modal.close(event);
            onOk?.();
          }}
          theme="primary"
        >
          {okTxt || "حسنا"}
        </Button>
      </div>
    </Modal.ClassicOverlay>
  );
}
export function SuccessAlert({ text, onOk, buttonProps = {} } = {}) {
  return (
    <Modal.ClassicOverlay className={css.loginpopup}>
      <div className={css.header}>
        <Modal.CloseButton />
      </div>
      <div className={css.body}>
        <Icon width={35} height={35} name="success" />
        <Linkify key={text} text={text || ""} />
      </div>
      <div className={css.footer}>
        <Button
          onClick={(event) => {
            Modal.close(event);
            onOk?.();
          }}
          theme="primary"
          {...buttonProps}
        >
          حسنا
        </Button>
      </div>
    </Modal.ClassicOverlay>
  );
}
export function PopupConfirm({
  children,
  text = "هل أنت متأكد من هذا الإجراء؟",
  onOk,
  onCancel = Modal.close,
  theme = "danger",
  title,
  onClick = () => {},
} = {}) {
  return React.cloneElement(children, {
    onClick: (e) => {
      onClick();
      Modal.open(
        <ClassicModal
          title={title || "تأكيد"}
          body={text}
          ok={{
            jsx: (
              <Button
                theme={theme}
                onClick={(evt) => {
                  Modal.close(evt);
                  onOk?.(evt);
                  children.props?.onClick?.(e);
                }}
              >
                نعم
              </Button>
            ),
          }}
          cancel={{ cb: onCancel, label: "إلغاء" }}
        />,
      )(e);
    },
  });
}

export const NewSingleActionPopup = ({ text, onOk }) => {
  return (
    <Modal.ClassicOverlay dir="rtl">
      <div className={css.popupContent}>
        <div className={css.header}>
          <div className={css.title}>عقار</div>
        </div>
        <div className={css.body}>
          <div className={css.text}>{text}</div>
          <div className={css.actions}>
            <Button
              className={css.okBtn}
              theme="primary"
              outline
              onClick={onOk || Modal.close}
            >
              حسنًا
            </Button>
          </div>
        </div>
      </div>
    </Modal.ClassicOverlay>
  );
};
